<template>
    <div class="tables-container">
        <div>
            <div class="years-container">
                <div class="selected-period">
                    <p class="period-text">View:</p>
                    <b-form-select v-model="selectedPeriod" :options="options"></b-form-select>
                </div>
                <div class="toggle-years">
                    <img
                        class="year-icon"
                        @click="getMonthlyKPI('prev')"
                        :src="getIcon + 'next-calendar.png'"
                    />
                    <p class="period-text">{{ currentYear }}</p>
                    <img @click="getMonthlyKPI('next')" :src="getIcon + 'next-calendar.png'" />
                </div>
            </div>
            <b-table
                class="table-responsive"
                striped
                :items="getKPIData"
                :fields="kpiTableHeader"
                responsive="lg"
                table-variant="secondary"
            >
            </b-table>
            <download-excel :data="getKPIData" :fields="csvFields" type="csv">
                <button class="export-kpi-btn">Download as .csv</button>
            </download-excel>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'KPI',
        data: () => ({
            csvFields: {},
            kpiTableHeader: [],
            KPIData: [],
            currentYear: null,
            selectedPeriod: 'Monthly',
            options: [
                { value: 'Monthly', text: 'Monthly' },
                { value: 'Quarterly', text: 'Quarterly' },
                { value: 'Yearly', text: 'Yearly' }
            ]
        }),
        methods: {
            getCSVField(data) {
                return data.reduce((acc, key) => {
                    acc[key] = key
                    return acc
                }, {})
            },
            getHeaderValues(data) {
                const keys = data.reduce(
                    (container, obj) => [...container, ...Object.keys(obj)],
                    []
                )
                return [...new Set(keys)]
            },
            async getMonthlyKPI(monthData) {
                let response = []
                this.currentYear =
                    monthData === 'next'
                        ? this.currentYear + 1
                        : monthData === 'prev'
                        ? this.currentYear - 1
                        : new Date().getFullYear()
                if (this.selectedPeriod === 'Monthly')
                    response = await axios.get('/admin/main-kpis/monthly/' + this.currentYear)
                if (this.selectedPeriod === 'Quarterly')
                    response = await axios.get(
                        '/admin/main-kpis/quarterly/' + this.currentYear
                    )
                if (this.selectedPeriod === 'Yearly')
                    response = await axios.get('/admin/main-kpis/yearly/' + this.currentYear)
                this.KPIData = response.data.kpiData
                this.kpiTableHeader = this.getHeaderValues(
                    this.selectedPeriod === 'Yearly' ? this.KPIData.reverse() : this.KPIData
                )
                this.csvFields = this.getCSVField(this.kpiTableHeader)
            }
        },
        watch: {
            selectedPeriod: async function () {
                await this.getMonthlyKPI()
            }
        },
        computed: {
            getKPIData() {
                return this.KPIData
            },
            getIcon() {
                return '/images/'
            }
        },
        async created() {
            await this.getMonthlyKPI()
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .selected-period {
        display: flex;
        align-items: center;
        gap: 5px;
    }
    .toggle-years img {
        cursor: pointer;
    }
    .year-icon {
        transform: rotate(180deg);
    }
    .toggle-years {
        display: flex;
        align-items: center;
        gap: 5px;
    }
    .years-container {
        display: flex;
        gap: 30px;
        margin-bottom: 20px;
    }
    .tables-container {
        display: flex;
        flex-direction: column;
        gap: 50px;
    }
    .export-kpi-btn {
        padding: 11px 50px 12px 50px;
        border-radius: 100px;
        background: #cdeb09;
        color: #000;
        @include base-font-18;
        font-weight: 550;
        line-height: 120%;
        border: 0;
    }
    .period-text {
        color: #000000;
        @include base-font-18;
        font-weight: 650;
        line-height: 120%;
        margin: 0;
    }
</style>
